import gql from 'graphql-tag';

export const getAuthorizeUrlMutation = gql`
  mutation GetAuthorizeUrl(
    $tenant: String!
    $userIdentifier: UserIdentifierInput!
  ) {
    getAuthorizeUrl(tenant: $tenant, userIdentifier: $userIdentifier) {
      authorizeUrl
    }
  }
`;
